import React, { createContext, useContext, useState, useEffect } from "react";

// Création du contexte
const SelectedContext = createContext();

// Hook personnalisé pour accéder facilement au contexte
export const useSelected = () => useContext(SelectedContext);

// Provider
export const SelectedProvider = ({ children }) => {
  const [selectedPerson, setSelectedPerson] = useState(() => {
    // On tente de récupérer depuis localStorage
    const saved = localStorage.getItem("selectedPerson");
    return saved ? JSON.parse(saved) : null;
  });

  const [selectedAccount, setSelectedAccount] = useState(() => {
    const saved = localStorage.getItem("selectedAccount");
    return saved ? JSON.parse(saved) : null;
  });

  // Persistance automatique dans localStorage
  useEffect(() => {
    if (selectedPerson) {
      localStorage.setItem("selectedPerson", JSON.stringify(selectedPerson));
    } else {
      localStorage.removeItem("selectedPerson");
    }
  }, [selectedPerson]);

  useEffect(() => {
    if (selectedAccount) {
      localStorage.setItem("selectedAccount", JSON.stringify(selectedAccount));
    } else {
      localStorage.removeItem("selectedAccount");
    }
  }, [selectedAccount]);

  return (
    <SelectedContext.Provider
      value={{ selectedPerson, setSelectedPerson, selectedAccount, setSelectedAccount }}
    >
      {children}
    </SelectedContext.Provider>
  );
};
